

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('CancellationReturnCtrl', function ($scope,$rootScope) {
$rootScope.title='Cancellation Policy';


});

